export const EVENT_CATEGORY = 'forgot_password_webpage';
export const REDIRECT_URL = 'https://m.p-y.tm/aee';
export const PAYTM_URL = 'https://paytm.com';
export const PAYTM_CARE_URL = 'https://paytm.com/care';
export const SCREEN_NAME = '/forgot_password';
